import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useLocation } from 'react-router-dom';
import '../../../../../node_modules/react-virtualized/styles.css';
// Components
import Header from './Header';
import SideNavMenu from 'shared/navigation/SideNavMenu';
import Modal from 'shared/modals/Modal';
import FilteringPanel from '../../filter';
import FavouritesOrdersGrid from '../../../../orders/components/grids/FavouritesOrdersGrid';
import CustomSearchModal from '../CustomSearchModal';
// Fetch
import {
  addFilter,
  updateFilter,
  deleteFilter,
  getFiltersForCurrentUser,
  getFilterFieldsForEntity,
} from 'src/fetch/filters';
// Consts
import { initialFilter } from '../../filter/constants';
import { setEnvironment } from '../../../../slices/environment';
import { useDispatch } from 'react-redux';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const entities = [
  {
    title: 'Orders',
    value: 'orders',
  },
  {
    title: 'Drivers',
    value: 'drivers',
  },
  {
    title: 'Organizations',
    value: 'organizations',
  },
  {
    title: 'Quote',
    value: 'quotes',
  },
];

const entityRoutes = {
  drivers: '/safety/drivers',
  orders: '/orders/orders',
  organizations: '/organizations/organizations',
  quotes: '/pricing/quotes'
};

const AppLayout = ({ history, children }) => {
  const location = useLocation();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const onNavOpen = () => setIsNavCollapsed(false);
  const onCollapse = () => setIsNavCollapsed(true);
  const [version, setVersion] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [showCustomSearch, setShowCustomSearch] = useState(false);
  const [showFavouriteOrders, setShowFavouriteOrders] = useState(false);
  const dispatch = useDispatch();

  const handleFilterApplied = ({ entity, filter }) => {
    window.sessionStorage.setItem(`${entity}.filter`, JSON.stringify(filter));
    const route = entityRoutes[entity];

    if (location.pathname === route) {
      window.location.reload();
    } else {
      history.push(route);
    }
    setShowFilter(false);
  };

  useEffect(() => {
    fetch('Version', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((version) => {
        setVersion(version);
        dispatch(setEnvironment(version.environment));
      })
      .catch(() => {
        console.error('Unable to get Version information.');
      });
  }, []);

  return (
    <div className='content-wrapper' id='wrapper'>
      <Header
        isNavCollapsed={isNavCollapsed}
        version={version}
        onNavOpen={onNavOpen}
        onFilterOpened={() => setShowFilter(true)}
        onFavouriteOrdersOpened={() => setShowFavouriteOrders(true)}
        onCustomSearchOpened={() => setShowCustomSearch(true)}
      />
      <SideNavMenu isCollapsed={isNavCollapsed} version={version} onCollapse={onCollapse} />
      <div className='main-content-wrapper'>
        <main role='main' className='main-content' id='main'>
          {children}
        </main>
        <Modal isOpen={showFilter} handleClose={() => setShowFilter(false)} containerStyle='large' title='Filtering'>
          <FilteringPanel
            entity={entities}
            onApply={handleFilterApplied}
            initialFilter={initialFilter}
            addFilter={addFilter}
            updateFilter={updateFilter}
            deleteFilter={deleteFilter}
            getFilters={getFiltersForCurrentUser}
            getFilterFields={getFilterFieldsForEntity}
          />
        </Modal>
        <Modal
          isOpen={showFavouriteOrders}
          handleClose={() => setShowFavouriteOrders(false)}
          containerStyle='medium'
          title='Favourite Orders'
        >
          <FavouritesOrdersGrid />
        </Modal>
        <Modal
          isOpen={showCustomSearch}
          handleClose={() => setShowCustomSearch(false)}
          title='Enter numbers to search for, then select criteria below.'
        >
          <CustomSearchModal onSearchSuccess={() => setShowCustomSearch(false)}/>
        </Modal>
      </div>
    </div>
  );
};

export default withRouter(AppLayout);
